import { useEffect, useState } from "react";

export type Route = {
	path: string;
	params: Record<string, string>;
};

const read = (): Route => {
	const raw = window.location.hash.slice(1) || "/";
	const qIdx = raw.indexOf("?");
	const path = qIdx === -1 ? raw : raw.slice(0, qIdx);
	const query = qIdx === -1 ? "" : raw.slice(qIdx + 1);
	const params: Record<string, string> = {};
	for (const [k, v] of new URLSearchParams(query)) params[k] = v;
	return { path, params };
};

export function useHashRoute(): Route {
	const [route, setRoute] = useState<Route>(read);
	useEffect(() => {
		const onHash = () => setRoute(read());
		window.addEventListener("hashchange", onHash);
		return () => window.removeEventListener("hashchange", onHash);
	}, []);
	return route;
}

export function navigate(path: string) {
	if (!path.startsWith("/")) path = `/${path}`;
	window.location.hash = path;
}

export function matchPath(routePath: string, pattern: string): { params: Record<string, string> } | null {
	const rp = routePath.split("/").filter(Boolean);
	const pp = pattern.split("/").filter(Boolean);
	if (rp.length !== pp.length) return null;
	const params: Record<string, string> = {};
	for (let i = 0; i < pp.length; i++) {
		const seg = pp[i]!;
		const val = rp[i]!;
		if (seg.startsWith(":")) params[seg.slice(1)] = decodeURIComponent(val);
		else if (seg !== val) return null;
	}
	return { params };
}
